import { memo } from "react";

import Skeleton from "../../../Skeleton/Skeleton";
import NegativeIcon from "../../../icons/NegativeIcon";
import NoData from "../NoData/NoData";

import { NumberValueProps } from "./types";
import styles from "./NumberValue.module.css";

const NumberValue = memo(function NumberValue({ value, loader }: NumberValueProps) {
  if (loader) return <Skeleton height={24} width={32} />;
  if (value === undefined || value === null) return <NoData />;
  if (value === -1) return <NegativeIcon />;
  return <p className={styles["table__metric-number"]}>{value}</p>;
});

export default NumberValue;

